import { render, staticRenderFns } from "./ArkemaUsers.vue?vue&type=template&id=c0be5272&scoped=true"
import script from "./ArkemaUsers.vue?vue&type=script&lang=ts"
export * from "./ArkemaUsers.vue?vue&type=script&lang=ts"
import style0 from "./ArkemaUsers.vue?vue&type=style&index=0&id=c0be5272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be5272",
  null
  
)

export default component.exports